import * as appActions from './app.actions';
import * as checkoutActions from './checkout.actions';
import * as supportActions from './support.actions';
import * as followupActions from './followup.actions';

const fromActions = {
  ...appActions,
  ...checkoutActions,
  ...supportActions,
  ...followupActions,
};

export { fromActions };
